"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-aluminum-extrusion";

const ADVANTAGES = [
	"prosConsAdv1",
	"prosConsAdv2",
	"prosConsAdv3",
	"prosConsAdv4",
	"prosConsAdv5",
	"prosConsAdv6",
] as const;

const DISADVANTAGES = [
	"prosConsDis1",
	"prosConsDis2",
	"prosConsDis3",
	"prosConsDis4",
	"prosConsDis5",
	"prosConsDis6",
] as const;

export default function AluminumExtrusionProsCons() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-center text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("prosConsTitle")}
				</h2>

				<div className="grid gap-6 lg:grid-cols-2 lg:gap-8">
					<div className="bg-[#edffd5]">
						<h3 className="bg-[#80c26a] px-6 py-4 text-lg font-bold text-black sm:px-7 md:text-xl">
							{t("prosConsAdvantagesTitle")}
						</h3>
						<div className="space-y-5 px-6 py-6 sm:px-7 sm:py-7">
							{ADVANTAGES.map((item) => (
								<p key={item} className="text-sm leading-relaxed text-black md:text-base">
									<strong className="font-bold">{t(`${item}Title`)}</strong>
									{t(`${item}Desc`)}
								</p>
							))}
						</div>
					</div>

					<div className="bg-[#f5f5f5]">
						<h3 className="bg-[#e5e5e5] px-6 py-4 text-lg font-bold text-black sm:px-7 md:text-xl">
							{t("prosConsDisadvantagesTitle")}
						</h3>
						<div className="space-y-5 px-6 py-6 sm:px-7 sm:py-7">
							{DISADVANTAGES.map((item) => (
								<p key={item} className="text-sm leading-relaxed text-black md:text-base">
									<strong className="font-bold">{t(`${item}Title`)}</strong>
									{t(`${item}Desc`)}
								</p>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
